import React from 'react';
import styled, { css } from 'styled-components';
import type { ColumnConfig } from './types';

export interface StyledPinLeftContainerProps {
  width: string;
}

const StyledPinLeftContainer = styled.div<StyledPinLeftContainerProps>`
  position: absolute;
  left: 0;
  top: 62px;
  width: 20px;
  background: #00800078;
  z-index: 1;
  overflow: hidden;
  background: white;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
  clip-path: inset(0px -15px 0px 0px);
  box-sizing: content-box;
  margin-bottom: 30px;
  ${(props) => css`
      width: ${props.width}};
    `}
`;

export interface PinLeftOverlayParams<T> {
  columnDivisions: number;
  fixedWidth: number;
  columnConfig: Array<ColumnConfig<T>>;
  content: JSX.Element;
}

const ADDITIONAL_PADDING = 16;

export const PinLeftOverlay = <T,>({ columnDivisions, fixedWidth, columnConfig, content }: PinLeftOverlayParams<T>) => {
  const formatOverlayWidth = (width: number) => `${(width / columnDivisions) * fixedWidth - ADDITIONAL_PADDING}px`;
  const width = columnConfig.length === 0 ? '0' : formatOverlayWidth(columnConfig[0].width);

  return (
    <StyledPinLeftContainer className="PIN_OVERLAY_WRAPPER" width={width}>
      {content}
    </StyledPinLeftContainer>
  );
};
